let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lQs6A")).then(() => parcelRequire('bmkcG'));